module.exports = __webpack_public_path__ + "static/media/png.ecdcd2ff.svg";